import { SharedModule } from './../shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { PaginationModule } from 'ngx-bootstrap';

import { CalendarRoutingModule } from './calendar-routing.module';
import { CalendarComponent } from './calendar.component';

// Third party
// Local
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PaginationModule,
    Ng2SmartTableModule,
    CalendarRoutingModule,
    SharedModule
  ],
  declarations: [CalendarComponent]
})
export class CalendarModule { }



// WEBPACK FOOTER //
// ./src/app/calendar/calendar.module.ts